<template>
  <!-- 用户流水控制 -->
  <div class="task-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" class="demo-form-inline">
        <!-- <el-form-item>
          <el-button type="primary" @click="openDialog(1)">添加队伍</el-button>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="handleExport"
            >导出胜利队伍</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-switch
            v-model="pk_status"
            :active-value="1"
            :inactive-value="0"
            active-text="开启PK"
            inactive-text="关闭PK"
            @change="changeEvent"
          ></el-switch>
        </el-form-item>
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box">
      <el-table
        :data="dataList"
        v-loading="loading"
        style="margin-bottom: 20px"
      >
        <el-table-column prop="id" label="ID" align="center"> </el-table-column>
        <el-table-column prop="name" label="队伍名称" align="center">
        </el-table-column>
        <el-table-column prop="image" label="队伍图片" align="center">
          <template slot-scope="{ row }">
            <img style="width: 50px" :src="row.image" alt="" />
          </template>
        </el-table-column>
        <el-table-column prop="is_pk" label="PK队伍" align="center">
          <template slot-scope="{ row }">
            <el-tag type="success" v-if="row.is_pk === 1">正在PK</el-tag>
            <el-tag type="info" v-else>未PK</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="tick_num" label="队伍票数" align="center">
        </el-table-column>
        <el-table-column prop="votes" label="队伍输赢" align="center">
          <template slot-scope="{ row }">
            <el-tag type="info" v-if="row.is_win === 0">待定</el-tag>
            <el-tag type="success" v-else-if="row.is_win === 1">赢</el-tag>
            <el-tag type="danger" v-else>输</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="action"
          label="操作"
          align="center"
          fixed="right"
        >
          <template slot-scope="{ row }">
            <el-button type="primary" size="small" @click="openDialog(2, row)"
              >编辑</el-button
            >
            <!-- <el-button type="danger" size="small" @click="deleteUser(row)"
              >删除</el-button
            > -->
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 弹窗 -->
    <AddTeamDialog
      v-model="dialogInfos"
      :visible="addVisible"
      @close="addVisible = false"
      @refresh="getData()"
    ></AddTeamDialog>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'
import saveFile from '@/utils/saveFile'
import AddTeamDialog from '../../components/votingQuiz/AddTeamDialog.vue'

export default {
  components: {
    AddTeamDialog
  },
  data() {
    return {
      addVisible: false,//添加队伍弹窗显示标志
      loading: false,//加载动画
      dataList: undefined,//数据列表
      dialogInfos: undefined,//传给弹窗的数据
      pk_status: 0,//PK开关,0是关闭，1是打开
      dataMeta: undefined,//底部跳转页面条
    }
  },
  created() {
    this.getData()//获取数据列表
    this.getSwitchStatus()//获取开关状态
  },
  methods: {
    getSwitchStatus(){
      //获取控制PK状态按钮
      getApiData('major_pk')
        .then(res => {
          if (res) {
            res.data ? this.pk_status = 1 : this.pk_status = 0
          }
        })
    },
    changeEvent() {
      //控制PK状态按钮
      let params = { "black": this.pk_status ? 1 : 0 }
      patchApiData('major_pk', params)
        .then(res => {
          this.$message.success('操作成功！')
        }).catch(err => {
          //关闭/打开红包按钮失败，还原标志
          this.pk_status = this.pk_status ? 0 : 1
        })

    },
    getData() {
      this.loading = true
      getApiData('major_list')
        .then(res => {
          this.dataList = res.list
          //设置底部导航条数据
          this.dataMeta = res
        })
        .finally(() => {
          this.loading = false
        })
    },
    openDialog(num, val) {
      //打开添加队伍弹窗
      this.addVisible = true
      if (num === 1) {

      }
      if (num === 2) {
        this.dialogInfos = JSON.parse(JSON.stringify(val))
      }
    },
    handleExport() {
      this.buttonLoading = true
      // let params = this.formData

      http
        .get(
          api + 'major_pk_export',
          {
            responseType: 'arraybuffer'
          }
        )
        .then(res => {
          saveFile(res, {
            type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            name: '胜利队伍人员.xlsx'
          })
        }).finally(() => {
          this.buttonLoading = false
        })
    },
  }

}
</script>
<style lang="less" scoped>
</style>